<style lang="sass">
.kit
  .uk-accordion
    .uk-accordion-title
      background-color: transparent !important
      color: #34495e !important
      /*border-bottom: 1px solid*/
  -webkit-box-shadow: 0px 2px 26px -5px rgba(52,73,94,0.52);
  -moz-box-shadow: 0px 2px 26px -5px rgba(52,73,94,0.52);
  box-shadow: 0px 2px 26px -5px rgba(52,73,94,0.52);
  .kit-header
    background-color: #AED47B
    padding: 10px 5px
    h2
      color: #ffffff !important
      margin-bottom: 0
  .kit-body
    padding: 20px
  .kit-footer
    
    
</style>

<template>
<div class="kit" v-if=kits>

  <div class="kit-header">
    <h2 class="uk-text-center">{{ kits[0].title }}</h2>
  </div>

  <div class="kit-body">
    <p class="uk-truncate"> {{ kits[0].description }} </p>

    <!--Switcher Nav-->
    <ul class="uk-subnav uk-subnav-pill" data-uk-switcher="{connect:'#my-id'}">
      <li><a href="">Basic</a></li>
      <li><a href="">Custom</a></li>
    </ul>

    <!--Switcher Items-->
    <ul id="my-id" class="uk-switcher">
      <li>
        <div class="uk-accordion" data-uk-accordion>

          <h3 class="uk-accordion-title">Courses <span class="uk-badge uk-badge-notification">{{ kits[0].packages.basic.courses.units }}</span> <i class="uk-icon uk-icon-caret-down uk-align-right"></i></h3>
          <div class="uk-accordion-content">
            <p class="uk-truncate"> {{ kits[0].packages.basic.courses.summary }} </p>
          </div>

          <h3 class="uk-accordion-title">Expert Support <i class="uk-icon uk-icon-check"></i> <i class="uk-icon uk-icon-caret-down uk-align-right"></i></h3>
          <div class="uk-accordion-content">
            <p class="uk-truncate"> {{ kits[0].packages.basic.expertHours.summary }} </p>
          </div>

          <h3 class="uk-accordion-title">Farm Visits <span class="uk-badge uk-badge-notification"> {{ kits[0].packages.basic.visits.units }} </span> <i class="uk-icon uk-icon-caret-down uk-align-right"></i></h3>
          <div class="uk-accordion-content">
            <p class="uk-truncate"> {{ kits[0].packages.basic.visits.summary }} </p>
          </div>

          <h3 class="uk-accordion-title">Prior Requirements <i class="uk-icon uk-icon-caret-down uk-align-right"></i></h3>
          <div class="uk-accordion-content">
            <table class="uk-table">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Description</th>
       
                </tr>
              </thead>
              <tbody>
                <tr v-for="requirement in kits[0].packages.basic.requirements">
                  <td> {{ requirement.name }} </td>
                  <td> {{ requirement.description }} </td>
                </tr>
              </tbody>
            </table>
           
          </div>

          <h3 class="uk-accordion-title">Inputs <i class="uk-icon uk-icon-check"></i> <i class="uk-icon uk-icon-caret-down uk-align-right"></i></h3>
          <div class="uk-accordion-content uk-padding-remove">
            <table class="uk-table">
              <thead>
                <tr>
                  <th>Item</th>
                  <th>Units</th>
                  <th>Cost</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="input in kits[0].packages.basic.inputs">
                  <td>{{ input.title }}</td>
                  <td>{{ input.units }}</td>
                  <td>{{ input.kitPrice }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <h2 class="uk-text-right uk-margin-right uk-margin-bottom" > Ksh. {{ kits[0].packages.basic.totalPrice }} </h2>
          <a class="uk-button uk-button-primary uk-button-large uk-clearfix uk-align-right" href="#basic-payment-modal" data-uk-modal> Pre-Order Now </a>
            </div>
          </li>

          <li>
            <div class="uk-accordion uk-panel uk-text-center" data-uk-accordion>
              <div>
              <h2>Call</h2>
              <a href="tel:+254718411704" class="uk-h1"> +254718411704 </a>
              <h2> or email </h2> 
               <a href="mailto:farm@kuza.io" class="uk-h1"> farm@kuza.io </a>
              </div>
            </div>
          </li>
        </ul>
      </div>

    </div>
    
    <div id="basic-payment-modal" class="uk-modal payment-modal">
      <payment-modal :total-price="kits[0].packages.basic.totalPrice"></payment-modal>
    </div>

</template>

<script>
  import store from '../store'
  import Vue from 'vue'
  import PaymentModal from './PaymentModal.vue'

  export default {

    name: "Starter-Kit",
    // route: {
    //   activate ({ next }) {
    //     if(this.kits) next()
    //   }
    // },
    data() {
      return {
      }
    },

    components: {
      PaymentModal
    },

    firebase: {
      kits: store.kits.limitToLast(25)
    },
    
    filters: {
      currency: function(value) {
        return value + ' /='
      }
    }
  }
</script>


/** WEBPACK FOOTER **
 ** StarterKit.vue?c54be796
 **/